export const START_DOCUMENT_NUMBER = 1000;
